export enum ApiRoutes {
  // Services
  SERVICE_CATEGORIES = "service-categories",
  CREATE_SERVICE = "service",
  UPDATE_SERVICE = "service/:id",
  DELETE_SERVICE = "service/:id",
  GET_SERVICE_ADMIN = "service/:id",
  SERVICES = "service",
  GET_SERVICE_DETAILS = "service-page/:id",
  UPDATE_SERVICE_DETAILS = "service-page",
  SERVICE_LIST_BY_CATEGORY = "service-product/for-consumer/:categoryName",
  

  // Exams
  CREATE_EXAM = "exam",
  UPDATE_EXAM = "exam/:id",
  DELETE_EXAM = "exam/:id",
  GET_EXAM = "exam/:id",
  EXAMS = "exam",

  // Degrees
  DEGREE_WITH_ACADEMIC = "degree/by-school/:id",
  DEGREE_FILTERED_BY_ACADEMICS = "degree/filter-by-school-academics/:id",
  DEGREE_CONTAINING_ACADEMIC = "degree/filter-containing-academic",
  CREATE_DEGREE = "degree",
  UPDATE_DEGREE = "degree/:id",
  DELETE_DEGREE = "degree/:id",
  GET_DEGREE = "degree/:id",
  DEGREES = "degree",

  // School Levels
  SCHOOL_LEVELS_WITH_ACADEMIC = "academic-secondary/levels-by-school/:id",

  // Schools
  SCHOOL_DELETE_IMAGE = "school/:id/delete-image",
  SCHOOL_BRANCHES = "school/:id/branches",
  SCHOOL_SIMPLE = "school?simple=1",
  CREATE_SCHOOL = "school",
  UPDATE_SCHOOL = "school/:id",
  DELETE_SCHOOL = "school/:id",
  GET_SCHOOL = "school/:id",
  SCHOOLS = "school",

  // Branches
  BRANCHES = "branch",
  FILTER_BRANCHES = "branch/filter",
  CREATE_BRANCH = "branch",
  GET_BRANCH = "branch/:id",
  DELETE_BRANCH = "branch/:id",
  UPDATE_BRANCH = "branch/:id",

  // Majors
  CREATE_MAJOR = "major",
  GET_MAJORS_FOR_PROGRAM_CLONE = "major/clone-program/:programId",
  UPDATE_MAJOR = "major/:id",
  DELETE_MAJOR = "major/:id",
  GET_MAJOR = "major/:id",
  MAJORS = "major",

  // Academic higher
  DEACTIVATE_ACADEMIC_HIGHER = "academic-higher/:id/deactivate",
  ACTIVATE_ACADEMIC_HIGHER = "academic-higher/:id/activate",
  CREATE_ACADEMIC_HIGHER = "academic-higher",
  UPDATE_ACADEMIC_HIGHER = "academic-higher",
  DELETE_ACADEMIC_HIGHER = "academic-higher/:id",
  GET_ACADEMIC_HIGHER = "academic-higher/:id",
  ACADEMICS_HIGHER = "academic-higher?",

  // Academic secondary
  DEACTIVATE_ACADEMIC_SECONDARY = "academic-secondary/:id/deactivate",
  ACTIVATE_ACADEMIC_SECONDARY = "academic-secondary/:id/activate",
  DELETE_ACADEMIC_SECONDARY = "academic-secondary/:id",
  UPDATE_ACADEMIC_SECONDARY = "academic-secondary",
  CREATE_ACADEMIC_SECONDARY = "academic-secondary",
  GET_ACADEMIC_SECONDARY = "academic-secondary/:id",
  ACADEMICS_SECONDARY = "academic-secondary?",

  // Programs-higher
  CHECK_PROGRAM_DUPLICATION_HIGHER = "program-higher/check-duplication/:id",
  DEACTIVATE_PROGRAM_HIGHER = "program-higher/:id/deactivate",
  DEACTIVATE_INTAKE_HIGHER = "program-higher/intake/:id/deactivate",
  ACTIVATE_PROGRAM_HIGHER = "program-higher/:id/activate",
  ACTIVATE_INTAKE_HIGHER = "program-higher/intake/:id/activate",
  CREATE_PROGRAM_HIGHER = "program-higher",
  CLONE_PROGRAM_HIGHER = "program-higher/clone",
  UPDATE_PROGRAM_HIGHER = "program-higher",
  DELETE_INTAKE_HIGHER = "program-higher/intake/:id",
  DELETE_PROGRAM_HIGHER = "program-higher/:id",
  ADD_PROGRAMS_WITH_AI_HIGHER = "program-higher/ai/:id",
  GET_PROGRAM_HIGHER = "program-higher/:id",
  PROGRAMS_HIGHER = "program-higher?",
  GET_COUNTRIES_CONTAINING_PROGRAMS_HIGHER = "program-higher/country",
  GET_VIEW_MORE_PROGRAM_HIGHER = "program-higher/:id/view-more",
  GET_PROGRAM_HIGHER_APPLY_AS = "program-higher/:id/apply",

  // Programs-secondary
  CHECK_PROGRAM_DUPLICATION_SECONDARY = "program-secondary/check-duplication/:id",
  DEACTIVATE_PROGRAM_SECONDARY = "program-secondary/:id/deactivate",
  DEACTIVATE_INTAKE_SECONDARY = "program-secondary/intake/:id/deactivate",
  ACTIVATE_PROGRAM_SECONDARY = "program-secondary/:id/activate",
  ACTIVATE_INTAKE_SECONDARY = "program-secondary/intake/:id/activate",
  CREATE_PROGRAM_SECONDARY = "program-secondary",
  DELETE_INTAKE_SECONDARY = "program-secondary/intake/:id",
  DELETE_PROGRAM_SECONDARY = "program-secondary/:id",
  GET_PROGRAM_SECONDARY = "program-secondary/:id",
  PROGRAMS_SECONDARY = "program-secondary?",
  GET_COUNTRIES_CONTAINING_PROGRAMS_SECONDARY = "program-secondary/country",
  GET_VIEW_MORE_PROGRAM_SECONDARY = "program-secondary/:id/view-more",
  GET_PROGRAM_SECONDARY_APPLY_AS = "program-secondary/:id/apply",

  // Language-course
  CHECK_LANGUAGE_COURSE_DUPLICATION = "language-course/check-duplication",
  CREATE_LANGUAGE_COURSE = "language-course",
  LANGUAGE_COURSES = "language-course?",
  LANGUAGES_WITH_COURSES = "language-course/languages-with-courses?",
  GET_LANGUAGE_COURSE = "language-course/:id",
  ACTIVATE_LANGUAGE_COURSE = "language-course/:id/activate",
  DEACTIVATE_LANGUAGE_COURSE = "language-course/:id/deactivate",
  DELETE_COURSE = "language-course/:id",
  GET_COUNTRIES_CONTAINING_COURSES = "language-course/country",
  GET_LANGUAGES_CONTAINING_COURSES = "language-course/language",
  GET_VIEW_MORE_LANGUAGE_COURSE = "language-course/:id/view-more",
  GET_LANGUAGE_COURSE_APPLY_AS = "language-course/:id/apply",

  // GET_PROGRAM_WITH_MAJOR = "program/:id?major=:majorId",
  GET_PROGRAM_MAJORS_HIGHER = "program-higher/:id/major",
  GET_PROGRAM_MAJOR_HIGHER = "program-higher/:programId/major/:majorId",
  ADD_PROGRAM_MAJORS_HIGHER = "program-higher/:id/major",
  EDIT_PROGRAM_MAJORS_HIGHER = "program-higher/:id/major/:majorId",

  // Service product
  SERVICES_CONTROLLER = "service-product",
  GET_SERVICES_LIST_FOR_PROVIDER = "service-product/for-provider",
  ONE_SERVICE = "service-product/:id",
  VIEW_ONE_SERVICE = "service-product/:id/view",
  GET_VIEW_MORE_SERVICE = "service-product/:id/view-more",
  GET_SERVICE_CONTACTS = "service-product/:id/contacts",

  // My Account
  MY_ACCOUNT = "my-account",
  MY_PROFILE = "my-account/profile",
  MY_PROFILE_EXAMS = "my-account/exams",
  MY_FAVORITES = "my-account/favorites",
  MY_FAVORITE_SCHOOLS = "my-account/favorite-school",
  MY_FAVORITE_MAJORS = "my-account/favorite-majors",
  MY_ACCOUNT_DOCUMENT = "my-account/document",
  MY_ACCOUNT_PHOTO_UPLOAD = "my-account/photo",
  CHANGE_PASSWORD = "my-account/change-password",
  MY_ACCOUNT_PACKAGE = "my-account/package",

  // Applications_OLD
  APPLICATIONS = "application",
  CREATE_APPLICATION = "application?apply=:apply",
  GET_APPLICATION = "application/:id",
  MAKE_APPLICATION_APPLIED = "application/:id/complete",
  UPDATE_APPLICATION = "application/:id?apply=:apply",
  DELETE_APPLICATION = "application/:id",

  // Auth
  LOGIN = "auth/login",
  REGISTER_STUDENT = "auth/register/student",
  REGISTER_PARENT = "auth/register/parent",
  REGISTER_AGENT = "auth/register/agent",
  REGISTER_SCHOOL = "auth/register/school",
  REGISTER_SERVICE_PROVIDER = "auth/register/service-provider",
  VERIFY = "auth/verify",
  FORGOT_PASSWORD = "auth/forgot-password",
  RESET_PASSWORD = "auth/reset-password?code=:code",

  // Users
  USERS = "user",
  CREATE_USER = "user",
  CREATE_SUPPORT = "user/support",
  GET_USER = "user/:id",
  UPDATE_USER = "user/:id",
  UPDATE_USER_ACCOUNT = "user/:id",
  DELETE_USER = "user/:id",
  VERIFY_USER = "user/:id/verify",
  VERIFY_PROFILE = "user/:id/verify-profile",
  REMOVE_FROM_FAVORITE = "user/:userId/favorite-school?id=:id",
  ASSIGN_USER_TO_SCHOOL = "user/:userId/assign-school/:schoolId",
  USER_PHOTO_UPLOAD = "user/:id/photo",
  USER_ACCOUNT_DOCUMENT = "user/:id/document",
  USER_APPLICATIONS = "user/:id/applications",
  USER_BRANCHES = "user/:id/branches",
  USER_DEGREES = "user/:id/degrees",
  USER_SCHOOL_ROLE = "user/:id/school-role",
  USER_PROFILE = "user/:id/profile",
  USER_PROFILE_EXAMS = "user/:id/exams",
  GET_USER_PACKAGE = "user/:id/payment/package",
  GET_USER_PAYMENTS_HISTORY = "user/:id/payment/history",
  USER_EMAIL_PREFERENCES = "user/:id/email-preferences",
  USER_TOKEN_EMAIL_PREFERENCES = "user/email-preferences",

  // Students
  STUDENTS = "user/student",
  MANAGED_STUDENTS = "user/:id/student?",
  STUDENT_COUNTRIES = "user/:id/student/country",
  STUDENT_NAMES = "user/:id/student/name",
  GET_STUDENT = "user/student/:id",
  CREATE_STUDENT = "user/student",
  UPDATE_STUDENT = "user/student/:id",
  GET_STUDENT_DETAILS = "user/:id/student-details",
  EDIT_STUDENT = "user/:id",

  // Payments
  PRODUCTS = "payment/products",
  MAKE_PAYMENT = "payment/create-product-checkout-session",
  MAKE_CUSTOM_PAYMENT = "payment/create-custom-checkout-session",
  MAKE_SERVICE_PAYMENT = "payment/create-service-checkout-session",
  MAKE_SUBSCRIPTION_PAYMENT = "payment/create-subscription-checkout-session",
  CANCEL_SUBSCRIPTION = "payment/cancel-subscription",
  GET_PACKAGE = "payment/package",
  GET_PAYMENTS_HISTORY = "payment/history",

  // Countries
  GET_FILTERED_COUNTRIES = "country/filter?userType=:userType&onlyForVerifiedUsers=:onlyForVerifiedUsers",

  // School Students
  GET_SCHOOL_STUDENTS = "school/:id/student?",
  GET_SCHOOL_STUDENTS_COUNTRIES = "school/:id/student/country",
  GET_SCHOOL_STUDENTS_NAMES = "school/:id/student/name",

  // Applications
  GET_STUDENTS_FOR_APPLY_AS = "user/:id/student/for-apply-as",
  UPLOAD_STUDENT_APPLICATION_FORM = "file/student-application-form",
  UPLOAD_STUDENT_REQUIRED_DOC = "file/student-required-doc",
  UPLOAD_STUDENT_EXTRA_DOC = "file/student-extra-doc",
  APPLICATION_HIGHER = "application-higher?",
  APPLICATION_SECONDARY = "application-secondary?",
  APPLICATION_LANGUAGE_COURSE = "application-language-course?",
  CHECK_APPLICATION_DUPLICATION_HIGHER = "application-higher/check-duplication",
  CHECK_APPLICATION_DUPLICATION_SECONDARY = "application-secondary/check-duplication",
  CHECK_APPLICATION_DUPLICATION_LANGUAGE_COURSE = "application-language-course/check-duplication",
  UPDATE_APPLICATION_STATUS_HIGHER = "application-higher/:id/update-status",
  UPDATE_APPLICATION_STATUS_SECONDARY = "application-secondary/:id/update-status",
  UPDATE_APPLICATION_STATUS_LANGUAGE_COURSE = "application-language-course/:id/update-status",
  GET_APPLICATION_HIGHER = "application-higher/:id",
  GET_APPLICATION_SECONDARY = "application-secondary/:id",
  GET_APPLICATION_LANGUAGE_COURSE = "application-language-course/:id",
  CANCEL_APPLICATION_SECONDARY = "application-secondary/:id/cancel",
  CANCEL_APPLICATION_HIGHER = "application-higher/:id/cancel",
  CANCEL_APPLICATION_LANGUAGE_COURSE = "application-language-course/:id/cancel",
  UPDATE_APPLICATION_HIGHER = "application-higher/:id",
  UPDATE_APPLICATION_SECONDARY = "application-secondary/:id",
  UPDATE_APPLICATION_LANGUAGE_COURSE = "application-language-course/:id",
  GET_APPLICATION_COUNT_FOR_DEACTIVATION_HIGHER = "application-higher/filter-for-deactivation?",
  GET_APPLICATION_COUNT_FOR_DEACTIVATION_SECONDARY = "application-secondary/filter-for-deactivation?",
  GET_APPLICATION_COUNT_FOR_DEACTIVATION_LANGUAGE_COURSE = "application-language-course/filter-for-deactivation?",

  // Billing
  BILLING_HIGHER = "billing-higher",
  BILLING_SECONDARY = "billing-secondary",
  BILLING_LANGUAGE_COURSE = "billing-language-course",
  UPLOAD_BILLING_RECEIPT_IMAGE = "file/billing-receipt-image",
  GET_BILLING_RECEIPTS = "billing?",
  GET_BILLING_STUDENTS_NAMES = "billing/student/name?",
  GET_BILLING_STUDENTS_COUNTRIES = "billing/student/country?",

  // Messages
  CREATE_MESSAGE = "message",
  GET_MESSAGES = "message/list?",
  GET_CONVERSATIONS = "message/conversation-list?",

  // Statistics
  GET_STATISTICS_BY_COUNTRY = "statistics/by-country?",
  GET_STATISTICS_BY_EDUCATION_TYPE = "statistics/by-education-type?",

  // Broadcast
  GET_SUBSCRIBERS_FOR_BROADCAST = "payment/subscriber",
  GET_STUDENTS_FOR_BROADCAST = "user/broadcast/student",
  GET_AGENTS_FOR_BROADCAST = "user/broadcast/agent",
  GET_PARENTS_FOR_BROADCAST = "user/broadcast/parent",
  GET_SCHOOL_USERS_FOR_BROADCAST = "user/broadcast/school",
  GET_SERVICE_PROVIDER_USERS_FOR_BROADCAST = "user/broadcast/service-provider",
  BROADCAST_EMAIL_TO_SELECTED_USERS = "user/broadcast",

  // Others
  UPLOAD_DOC = "file/document",
  UPLOAD_APPLICATION = "file/application-form",
  UPLOAD_MESSAGE_ATTACHED_FILE = "file/message-attachment",
  UPLOAD_PROGRAM_DETAIL_FILE = "file/program-detail-file",
  UPLOAD_LANGUAGE_COURSE_DETAIL_FILE = "file/language-course-detail-file",
  UPLOAD_SERVICE_DETAIL_FILE = "file/service-product-detail-file",
}
